import { render, staticRenderFns } from "./Timestamp.vue?vue&type=template&id=ef3936c0&scoped=true&"
import script from "./Timestamp.vue?vue&type=script&lang=js&"
export * from "./Timestamp.vue?vue&type=script&lang=js&"
import style0 from "./Timestamp.vue?vue&type=style&index=0&id=ef3936c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef3936c0",
  null
  
)

export default component.exports